import constants from 'common/constants'
import {withClient} from 'common/helpers/clientInfo'

import {
  ACTIVATE_VERSION,
  ADD_CONSTRAINT_BY_ID,
  ADD_NEW_DURATION,
  BULK_UPDATE_WORKLOAD,
  CALCULATE_TIMETABLE_TOKENS,
  CHECK_ALL_SUBJECTS_ENROLLMENT,
  CREATE_TIMETABLE_CLASS_VENUES,
  DEACTIVATE_VERSION,
  DELETE_CONSTRAINT,
  DELETE_DURATION,
  DELETE_TIMETABLE,
  DELETE_TIMETABLE_VERSION,
  DIAGNOSE_TIMETABLE_FAILURES,
  GENERATE_PROMPT,
  GENERATE_TIMETABLE_REPORT_PDF,
  GET_ACCESS_TOKEN,
  GET_ALL_CONSTRAINTS,
  GET_ALL_DURATIONS,
  GET_ALL_VERSIONS,
  GET_CONSTRAINT_BY_ID,
  GET_FREE_TEACHERS,
  GET_FREE_VENUES,
  GET_RECENT_TIMETABLE_VERSIONS,
  GET_SAMPLE_GENERATION_STATUS,
  GET_TIMETABLE,
  GET_TIMETABLE_CATEGORIES,
  GET_TIMETABLE_LIST_DATA,
  GET_TIMETABLE_REPORT,
  GET_TIMETABLE_STATUS,
  GET_TIMETABLE_STUDENT_SUBJECTS,
  GET_TIMETABLE_SUBCATEGORIES,
  GET_TIMETABLE_SUBCATEGORY_BY_ID,
  GET_TIMETABLE_WARNING,
  GET_WORK_BREAK_DOWN_BY_LEVEL_ID,
  LOG_SOCKET_MESSAGE,
  LOG_TIMETABLE_EXPORT,
  TRACK_TIMETABLE_EVENT,
  UPDATE_CONSTRAINT,
  UPDATE_CONSTRAINT_LIST,
  UPDATE_DURATION,
  UPDATE_TIMETABLE,
  UPDATE_VERSION_NAME,
  UPDATE_WORK_BREAK_DOWN_FREQUENCY,
  VALIDATE_CLASS_SUBJECT_LOAD,
  VALIDATE_CONCURRENT_SUBJECTS,
  VALIDATE_SUBJECT_PAIRS_CONCURRENT,
  VALIDATE_TEACHER_AVAILABILITY,
  VALIDATE_TIMETABLE,
  VALIDATE_TIMETABLE_CAPACITY,
} from './ActionTypes/ApiActionTypes'
import {
  REDUX_CONSTRAINTS_UPDATED_TICK,
  REDUX_DECREMENT_CATEGORY_PREFERENCE_COUNT,
  REDUX_DECREMENT_SUBCATEGORY_PREFERENCE_COUNT,
  REDUX_GET_ALL_CONSTRAINTS,
  REDUX_GET_CONSTRAINT_BY_ID,
  REDUX_GET_TIMETABLE_CATEGORIES,
  REDUX_GET_TIMETABLE_LIST_DATA,
  REDUX_GET_TIMETABLE_SUBCATEGORIES,
  REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID,
  REDUX_INCREMENT_CATEGORY_PREFERENCE_COUNT,
  REDUX_INCREMENT_SUBCATEGORY_PREFERENCE_COUNT,
  REDUX_SET_SELECTED_DURATION_ID,
  REDUX_SET_SELECTED_LEVEL_ID,
  REDUX_SET_SELECTED_VERSION_ID,
} from './ActionTypes/ReduxActionTypes'

export const getTimetableCategories = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_CATEGORIES,
    payload: {
      apiUrl: constants.api_get_timetable_categories,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_CATEGORIES : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableSubCategories = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_SUBCATEGORIES,
    payload: {
      apiUrl: constants.api_get_timetable_subcategories,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_SUBCATEGORIES : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableSubCategoriesByID = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_SUBCATEGORY_BY_ID,
    payload: {
      apiUrl: constants.api_get_timetable_subcategories,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID : '',
      onSuccess,
      onFailure,
    },
  }
}

export const addConstraint = (id, body, onSuccess, onFailure) => {
  // Ensure we pass specialResponseFormat so SagaHelper treats statusCode/error correctly
  return {
    type: ADD_CONSTRAINT_BY_ID,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_add_constraint,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
      specialResponseFormat: true, // <-- THIS LINE IS NEW AND CRITICAL FOR NEW BACKEND, SOLVES THE MISMATCH OF STATUS CODE AND ERROR
    },
  }
}

// Local reducers helpers to update counts and tick
export const incrementCategoryPreferenceCount = (categoryId, delta = 1) => ({
  type: REDUX_INCREMENT_CATEGORY_PREFERENCE_COUNT,
  payload: {categoryId, delta},
})

export const incrementSubCategoryPreferenceCount = (subCategoryId, delta = 1) => ({
  type: REDUX_INCREMENT_SUBCATEGORY_PREFERENCE_COUNT,
  payload: {subCategoryId, delta},
})

export const decrementCategoryPreferenceCount = (categoryId, delta = 1) => ({
  type: REDUX_DECREMENT_CATEGORY_PREFERENCE_COUNT,
  payload: {categoryId, delta},
})

export const decrementSubCategoryPreferenceCount = (subCategoryId, delta = 1) => ({
  type: REDUX_DECREMENT_SUBCATEGORY_PREFERENCE_COUNT,
  payload: {subCategoryId, delta},
})

export const constraintsUpdatedTick = () => ({
  type: REDUX_CONSTRAINTS_UPDATED_TICK,
})

export const getAllConstraints = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_ALL_CONSTRAINTS,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_all_constraints,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_ALL_CONSTRAINTS : '',
      onFailure,
    },
  }
}

export const deleteConstraint = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_CONSTRAINT,
    payload: {
      apiUrl: constants.api_delete_constraint(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getConstraintById = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_CONSTRAINT_BY_ID,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_timetable_constraints,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_CONSTRAINT_BY_ID : '',
      onFailure,
    },
  }
}

export const updateConstraint = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_CONSTRAINT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_update_constraint(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const updateConstraintList = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_CONSTRAINT_LIST,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_update_constraint_list,
      getString: '',
      specialResponseFormat: true,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const generateTimetable = (body, onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      body,
      header: 'application/json',
      reduxActionType: '',
      onFailure,
    },
  }
}

export const requestTimetable = (body, onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_request_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const deleteTimetable = (onSuccess, onFailure) => {
  return {
    type: DELETE_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_delete_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getTimetableReport = (onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_REPORT,
    payload: {
      apiUrl: constants.api_get_timetable_report,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableStatus = (onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_STATUS,
    payload: {
      apiUrl: constants.api_get_timetable_status,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/**
 * da1timetable sample: whether the free sample generation limit is reached ({isSample, limitReached}),
 * asked before the generation queue opens.
 */
export const getSampleGenerationStatus = (onSuccess, onFailure) => {
  return {
    type: GET_SAMPLE_GENERATION_STATUS,
    payload: {
      apiUrl: constants.api_sample_generation_status,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableStudentSubjects = (levelId, onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_STUDENT_SUBJECTS,
    payload: {
      apiUrl: constants.api_get_timetable_student_subjects(levelId),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableListData = (levelId, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_LIST_DATA,
    payload: {
      apiUrl: constants.api_get_timetable_list_data(levelId),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_LIST_DATA : '',
      onSuccess,
      onFailure,
    },
  }
}

export const logSocketMessage = (data, onSuccess, onFailure) => {
  return {
    type: LOG_SOCKET_MESSAGE,
    payload: {
      apiUrl: constants.api_socket_message_log,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const logTimetableExport = (data, onSuccess, onFailure) => {
  return {
    type: LOG_TIMETABLE_EXPORT,
    payload: {
      apiUrl: constants.api_timetable_log_export,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      specialResponseFormat: true,
      onSuccess,
      onFailure,
    },
  }
}

// Credit wall, generation route, timetable funnel and screens, export — every
// caller goes through here, so `client` is merged into the event's metadata once.
export const trackTimetableEvent = (data, onSuccess, onFailure) => {
  return {
    type: TRACK_TIMETABLE_EVENT,
    payload: {
      apiUrl: constants.api_timetable_track_event,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {...data, metadata: withClient(data?.metadata)},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const generatePrompt = (onSuccess, onFailure) => {
  return {
    type: GENERATE_PROMPT,
    payload: {
      apiUrl: constants.api_generate_prompt,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      specialResponseFormat: true,
      onSuccess,
      onFailure,
    },
  }
}

export const validateTimetableV2 = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_TIMETABLE,
    payload: {
      apiUrl: constants.api_validate_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      specialResponseFormat: true,
      onSuccess,
      onFailure,
    },
  }
}

export const validateTeacherAvailability = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_TEACHER_AVAILABILITY,
    payload: {
      apiUrl: constants.api_validate_teacher_availability,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const generateTimetableReportPDF = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_TIMETABLE_REPORT_PDF,
    payload: {
      apiUrl: constants.api_timetable_report_generation_pdf,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getWorkBreakDownByLevelId = (body, onSuccess, onFailure) => {
  return {
    type: GET_WORK_BREAK_DOWN_BY_LEVEL_ID,
    payload: {
      apiUrl: constants.api_get_work_break_down_by_level_id,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      // body: body,
      body: {
        level_id: body.level_id,
        duration_id: body.duration_id,
      },
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateWorkBreakDownFrequency = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_WORK_BREAK_DOWN_FREQUENCY,
    payload: {
      apiUrl: constants.api_update_work_break_down_frequency(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const bulkUpdateWorkload = (body, onSuccess, onFailure) => {
  return {
    type: BULK_UPDATE_WORKLOAD,
    payload: {
      apiUrl: constants.api_bulk_update_workload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addNewDuration = (body, onSuccess, onFailure) => {
  return {
    type: ADD_NEW_DURATION,
    payload: {
      apiUrl: constants.api_add_new_duration,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateDuration = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_DURATION,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_update_duration(id),
      specialResponseFormat: true,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const deleteDuration = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_DURATION,
    payload: {
      apiUrl: constants.api_delete_duration(id),
      specialResponseFormat: true,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getAllDurations = (body, onSuccess, onFailure) => {
  return {
    type: GET_ALL_DURATIONS,
    payload: {
      apiUrl: constants.api_get_all_durations,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getAllVersions = (body, onSuccess, onFailure) => {
  return {
    type: GET_ALL_VERSIONS,
    payload: {
      apiUrl: constants.api_get_all_versions,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteTimetableVersion = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_TIMETABLE_VERSION,
    payload: {
      apiUrl: constants.api_delete_timetable_version(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const activateVersion = (body, onSuccess, onFailure) => {
  return {
    type: ACTIVATE_VERSION,
    payload: {
      apiUrl: constants.api_activate_version,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateVersionName = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_VERSION_NAME,
    payload: {
      apiUrl: constants.api_update_version_name,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deactivateVersion = (version_id, onSuccess, onFailure) => {
  return {
    type: DEACTIVATE_VERSION,
    payload: {
      apiUrl: constants.api_deactivate_version(version_id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: {version_id},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateTimetable = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_TIMETABLE,
    payload: {
      apiUrl: constants.api_update_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getAccessToken = (onSuccess, onFailure) => {
  return {
    type: GET_ACCESS_TOKEN,
    payload: {
      apiUrl: constants.api_get_access_token,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

// Redux actions for setting selected level, duration and version IDs
export const setSelectedLevelId = (levelId) => {
  return {
    type: REDUX_SET_SELECTED_LEVEL_ID,
    payload: levelId,
  }
}

export const setSelectedDurationId = (durationId) => {
  return {
    type: REDUX_SET_SELECTED_DURATION_ID,
    payload: durationId,
  }
}

export const setSelectedVersionId = (versionId) => {
  return {
    type: REDUX_SET_SELECTED_VERSION_ID,
    payload: versionId,
  }
}

export const getTimetableWarning = (body, onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_WARNING,
    payload: {
      apiUrl: constants.api_timetable_warning,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const validateConcurrentSubjects = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_CONCURRENT_SUBJECTS,
    payload: {
      apiUrl: constants.api_validate_concurrent_subjects,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const createClassVenues = (body, onSuccess, onFailure) => {
  return {
    type: CREATE_TIMETABLE_CLASS_VENUES,
    payload: {
      apiUrl: constants.api_timetable_create_class_venues,
      getString: '',
      useBaseURL: true,
      specialResponseFormat: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

// https://api-dev-ai.ilmversity.net/api/v1/timetable/validate-timetable-capacity

export const validateTimetableCapacity = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_TIMETABLE_CAPACITY,
    payload: {
      apiUrl: constants.api_validate_timetable_capacity,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

// https://api-dev-ai.ilmversity.net/api/v1/timetable/validate-subject-pairs-concurrent
export const validateSubjectPairsConcurrent = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_SUBJECT_PAIRS_CONCURRENT,
    payload: {
      apiUrl: constants.api_validate_subject_pairs_concurrent,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const diagnoseTimetableFailures = (body, onSuccess, onFailure) => {
  return {
    type: DIAGNOSE_TIMETABLE_FAILURES,
    payload: {
      apiUrl: constants.api_diagnose_timetable_failures,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getFreeTeachers = (body, onSuccess, onFailure) => {
  return {
    type: GET_FREE_TEACHERS,
    payload: {
      apiUrl: constants.api_get_free_teachers,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const calculateTimetableTokens = (body, onSuccess, onFailure) => {
  return {
    type: CALCULATE_TIMETABLE_TOKENS,
    payload: {
      apiUrl: constants.api_calculate_timetable_tokens,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getFreeVenues = (body, onSuccess, onFailure) => {
  return {
    type: GET_FREE_VENUES,
    payload: {
      apiUrl: constants.api_get_free_venues,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const validateClassSubjectLoad = (body, onSuccess, onFailure) => {
  return {
    type: VALIDATE_CLASS_SUBJECT_LOAD,
    payload: {
      apiUrl: constants.api_validate_class_subject_load,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const checkAllSubjectsEnrollment = (body, onSuccess, onFailure) => {
  return {
    type: CHECK_ALL_SUBJECTS_ENROLLMENT,
    payload: {
      apiUrl: constants.api_check_all_subjects_enrollment,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      specialResponseFormat: true,
      onSuccess,
      onFailure,
    },
  }
}

export const getRecentTimetableVersions = (onSuccess, onFailure) => {
  return {
    type: GET_RECENT_TIMETABLE_VERSIONS,
    payload: {
      apiUrl: constants.api_get_recent_timetable_versions,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
